import { h, render } from 'preact';
import {gtag, getAll, DEFAULT_CONSENT} from './preferences';

import App from './components/App/App';

const DevBrosCookies = function(settings) {
  const cookieDiv = document.createElement('div');
  cookieDiv.id = 'cookieBanner';
  document.body.appendChild(cookieDiv);

  const customSettings = settings;
  if (!customSettings) {
    console.error(
      'No suitable cookie preferences found. DevBrosCookies sadly exiting the scene.'
    );
    return;
  }
  attachSettings(cookieDiv.id, customSettings);

  const consent = getAll();
  if (consent) {
    const update = DEFAULT_CONSENT;
    for (const key of consent) {
      update[key] = 'granted';
    }
    gtag('consent', 'update', update);
  }
  render(<App config={customSettings} />, cookieDiv);
};

// Manually open settings window
const attachSettings = (cookieContainerId, settings) => {
  const settingsButtons = document.querySelectorAll('#dbCookies');
  if (settingsButtons) {
    for (const button of settingsButtons) {
      button.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector(`#${cookieContainerId}`).remove();
        const cookieDiv = document.createElement('div');
        cookieDiv.id = cookieContainerId;
        document.body.appendChild(cookieDiv);
        render(<App opened config={settings}/>, cookieDiv);
      });
    }
  }
};

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
  gtag('consent', 'default', DEFAULT_CONSENT);
  window.DevBrosCookies = DevBrosCookies;
  if (window.drupalSettings && window.drupalSettings.db_cookies) {
    DevBrosCookies(window.drupalSettings.db_cookies);
  }
}
